import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import settingService from './settingService';

const initialState = {
  customization: {
    customizationState: {
      updataData: '',
      gettingUpdataDataState: '',
      getUpdatedSettingByName: '',
    }, // status , response and message coming here for  customization
    customizationStateError: false,
    customizationStateSuccess: false,
    customizationStateLoading: false,
    customizationErrorMsg: '',
    getCustomError: false,
    getCustomSuccess: false,
    getCustomLoadings: true,
    // __________getUpdatedSettingByName_____
    SettingByNameError: false,
    SettingByNameSuccess: false,
    SettingByNameLoading: true,
    SettingByNameErrorMsg: '',
  },
  // img , color nd bg coming here
  bgStoreValue: '',

  // no more use of color image fille
  color: {
    colorA: '',
    colorB: '',
  },
  imageFile: {
    imageFileState: '',
  },
  favIcon: {
    favIconState: '',
  },
  branding: {
    brandingName: '',
    brandingUrl: '',
    brandingColor: '',
    checkedValue: '',
  },
  font: {
    fontSize: '',
    fontType: '',
  },
  seoSettings: {
    metaStatus: '',
    title: '',
    description: '',
    seoPicture: '',
  },
};

// _______________________customization response function and services calling
export const customizingSetting = createAsyncThunk('customization/customizingSetting', async (data, thunkAPI) => {
  try {
    const response = await settingService.customizingSetting(data);
    return response;
  } catch (error) {
    // handle all error like with status code  404 or 500 or 300 , not under 200
    const errorMsg =
      (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
    return thunkAPI.rejectWithValue(errorMsg);
  }
});

// _______________________customization  getting response function and services calling
export const gettingSettingUpdataData = createAsyncThunk(
  'getSettingData/gettingSettingUpdataData',
  async (datasdss, thunkAPI) => {
    try {
      const response = await settingService.gettingSettingUpdataData(datasdss);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const getScreenPreviewSetting = createAsyncThunk(
  'getScreenPreview/getScreenPreviewSetting',
  async (datasdss, thunkAPI) => {
    try {
      const response = await settingService.getScreenPreviewSetting(datasdss);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

const settingFieldSlice = createSlice({
  name: 'settingField',
  initialState,
  reducers: {
    resetupdataData:(state)=>{
      state.customization.customizationState.updataData=''
    },
    selectBgValue: (state, action) => {
      state.bgStoreValue = action.payload;
    },
    selectColor: (state, action) => {
      state.color = action.payload;
    },
    selectImage: (state, action) => {
      state.imageFile.imageFileState = action.payload;
    },
    selectFavIcon: (state, action) => {
      state.favIcon.favIconState = action.payload;
    },
    selectBrandName: (state, action) => {
      state.branding.brandingName = action.payload;
    },
    selectBrandUrl: (state, action) => {
      state.branding.brandingUrl = action.payload;
    },
    selectBrandCheck: (state, action) => {
      state.branding.checkedValue = action.payload;
    },
    selectBrandColor: (state, action) => {
      state.branding.brandingColor = action.payload;
    },
    selectFont: (state, action) => {
      state.font = action.payload;
    },
    setSeoSetting: (state, action) => {
      state.seoSettings = action.payload;
    },
    resetState: (state) => ({ ...state, color: {}, imageFile: {} }),
  },
  extraReducers: (builder) => {
    builder
      // ________________________ update customization  setting ___________________

      .addCase(customizingSetting.pending, (state) => {
        state.customization.customizationStateLoading = true;
      })
      .addCase(customizingSetting.fulfilled, (state, action) => {
        state.customization.customizationStateLoading = false;
        state.customization.customizationStateSuccess = true;
        state.customization.customizationState.updataData = action.payload;
      })
      .addCase(customizingSetting.rejected, (state, action) => {
        state.customization.customizationStateLoading = false;
        state.customization.customizationStateError = true;
        state.customization.customizationErrorMsg = action.payload; // error from catch will come here via action.payload and update errorMsg
      })

      // getting updatted data
      .addCase(gettingSettingUpdataData.pending, (state) => {
        state.customization.getCustomLoadings = true;
      })
      .addCase(gettingSettingUpdataData.fulfilled, (state, action) => {
        state.customization.getCustomLoadings = false;
        // state.customization.customizationStateSuccess = true;
        state.customization.customizationState.gettingUpdataDataState = action.payload;
      })
      .addCase(gettingSettingUpdataData.rejected, (state, action) => {
        state.customization.getCustomLoadings = false;
        state.customization.customizationStateError = true;
        state.customization.customizationErrorMsg = action.payload; // error from catch will come here via action.payload and update errorMsg
      })
      // _________________get screen preview settiing____________
      .addCase(getScreenPreviewSetting.pending, (state) => {
        state.customization.SettingByNameLoading = true;
      })
      .addCase(getScreenPreviewSetting.fulfilled, (state, action) => {
        state.customization.SettingByNameLoading = false;
        state.customization.SettingByNameSuccess = true;
        state.customization.customizationState.getUpdatedSettingByName = action.payload;
      })
      .addCase(getScreenPreviewSetting.rejected, (state, action) => {
        state.customization.SettingByNameLoading = false;
        state.customization.SettingByNameError = true;
        state.customization.SettingByNameErrorMsg = action.payload; // error from catch will come here via action.payload and update errorMsg
      });
  },
});
export const seletctFieldValues = (state) => state.settingField;

export const {
  selectColor,
  selectBrandColor,
  selectBrandName,
  selectBrandUrl,
  selectBrandCheck,
  selectImage,
  selectFont,
  selectFavIcon,
  resetState,
  selectBgValue,
  setSeoSetting,
  resetupdataData
} = settingFieldSlice.actions;
export default settingFieldSlice.reducer;
